import React from "react";
import ankitImg from "../assets/css/ankit.png";
import suruchiImg from "../assets/css/suruchi.png";
import sejalImg from "../assets/css/sejal.png";
import personArtwork from "../assets/css/person.jpg";
import Manan from "../assets/css/MananShah.jpeg";

function OurTeam() {
  const members = [
    { name: "Suruchi Shah", role: "Co-Founder", image: suruchiImg },
    { name: "Manan Shah", role: "Co-Founder", image: Manan },
    { name: "Ankit Shah", role: "Director of Operations", image: ankitImg },
    { name: "Sejal Rana", role: "Property Operations Coordinator", image: sejalImg },

  ];

  return (
    <section
      className="our-team-section"
      id="ourteam"
      style={{ paddingBottom: "70px" }}
    >
      <div
        className="auto-container"
        style={{ maxWidth: "1400px", width: "95%", margin: "0 auto" }}
      >
        <div className="section-title text-center">
          <span className="section-title__tagline">Our Team</span>
          <h2 className="section-title__title">Meet The Team</h2>
        </div>
        <div className="row">
          {members.map((m, i) => (
            <div
              key={m.name}
              className="col-xl-3 col-lg-3 col-md-6 col-sm-6 wow fadeInUp"
              data-wow-delay={`${i * 150}ms`}
              data-wow-duration="1200ms"
              style={{ marginBottom: "30px" }}
            >
              <div
                className="team-card"
                style={{
                  background: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                  overflow: "hidden",
                  minHeight: "520px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  className="team-card__image"
                  style={{ height: "360px", overflow: "hidden", background: "#ebebeb" }}
                >
                  <img
                    src={m.image}
                    alt={m.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "top",
                      display: "block",
                      mixBlendMode: "multiply",
                    }}
                  />
                </div>
                <div style={{ padding: "20px" }}>
                  <h5 style={{ margin: 0, fontSize: "18px" }}>Member</h5>
                  <p style={{ margin: "10px 0 0", fontSize: "16px" }}>
                    {m.name} - {m.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurTeam;
